var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.1H19M8 9V15M12 9V15M13 19.1H7C4.8 19.1 3 17.3 3 15.1V5.1H17V15.1C17 17.3 15.2 19.1 13 19.1ZM13 5.1H7V3C7 1.9 7.9 1 9 1H11C12.1 1 13 1.9 13 3V5.1Z",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash24);
export default __webpack_public_path__ + "static/media/trash-24.04b287d9f7f26a5bd28be6921ec29fcb.svg";
export { ForwardRef as ReactComponent };